import { Menu, MenuButton, MenuDivider, MenuItem } from '@szhsin/react-menu'
import { useIsAuthenticated } from '@azure/msal-react'
import { useAppleCalendars } from '../../hooks/AppleCalDAV'
import { OutlookCalendarSection } from './components/OutlookCalendarSection'
import { GoogleCalendarSection } from './components/GoogleCalendarSection'
import { AppleCalendarSection } from './components/AppleCalendarSection'
import {
  useHasGoogleAccounts,
  useGoogleAccountStatus,
} from '../../contexts/GoogleCalendar'
import { useCalendarAuth } from '../../contexts/CalendarAuth/CalendarAuthContext'

export function CalendarMenu() {
  const { data: hasGoogleAccounts = false } = useHasGoogleAccounts()
  const { data: googleAccountStatus } = useGoogleAccountStatus()
  const { data: appleCalendars = [] } = useAppleCalendars()
  const hasAppleCalendars =
    Array.isArray(appleCalendars) && appleCalendars.length > 0

  const isGoogleSignedIn = hasGoogleAccounts
  const isAppleSignedIn = hasAppleCalendars
  const isMsSignedIn = useIsAuthenticated()
  const { isAnyAuthLoading } = useCalendarAuth()

  // Check for Google account errors first (highest priority)
  const hasGoogleErrors =
    (googleAccountStatus?.hasErrors ?? false) ||
    (googleAccountStatus?.hasExpired ?? false)

  const menuIcon = isAnyAuthLoading
    ? 'fa-solid fa-circle-notch fa-spin'
    : hasGoogleErrors
      ? 'fa-regular fa-calendar-xmark'
      : 'fa-regular fa-calendar-circle-user'

  return (
    <Menu
      portal
      align='start'
      boundingBoxPadding='30px 0px 0px 0px'
      menuClassName='min-w-[320px]'
      menuButton={
        <MenuButton className='group relative mt-0 rounded-md p-1 transition-all duration-150 hover:bg-gray-100 dark:hover:bg-gray-800'>
          <i
            className={`${menuIcon} text-base ${
              isAnyAuthLoading
                ? 'text-blue-500 dark:text-blue-400'
                : hasGoogleErrors
                  ? 'text-red-500'
                  : isGoogleSignedIn || isAppleSignedIn || isMsSignedIn
                    ? 'text-green-600 dark:text-green-400'
                    : 'text-gray-600 dark:text-gray-400'
            }`}
            aria-hidden='true'
          />
        </MenuButton>
      }
    >
      <MenuItem disabled>
        <span className='text-xs font-bold text-gray-400 dark:text-gray-400'>
          CALENDAR ACCOUNTS
        </span>
      </MenuItem>
      <MenuDivider />
      <AppleCalendarSection />
      <MenuDivider />
      <GoogleCalendarSection />
      <MenuDivider />
      <OutlookCalendarSection />
    </Menu>
  )
}
